import {Modal} from "react-bootstrap";
import React, {Fragment, useContext, useEffect, useState} from "react";
import 'react-medium-image-zoom/dist/styles.css'
import Translate from "../../components/Translate";
import {LoaderContext} from "../../context/LoaderContext";
import NsModalHeader from "../../components/modal/NsModalHeader";
import NsDataTable from "../../components/tabelle/NsDataTable";
import {getSociApi} from "../../services/UtentiServices";
import {assegnaCertificatoNuovoSocioApi} from "../../services/CertificatiServices";
import {useSociUtils} from "../../hooks/useSociUtils";

export default function ModalCambioSocioCert({show, handleClose, certificato, postUpdate}) {

    const [nome, setNome] = useState()
    const [cognome, setCognome] = useState()
    const [socio, setSocio] = useState()
    const [soci, setSoci] = useState([])

    const {startChiamata, endChiamata} = useContext(LoaderContext);
    const {getRigaInfoSocio} = useSociUtils({
        reloadFunction: () => {}
    });

    async function getSoci() {
        let f = {
            pag: '-1'
        };
        if (nome && nome !== '') {
            f.nome = nome;
        }
        if (cognome && cognome !== '') {
            f.cognome = cognome;
        }

        startChiamata();

        const response = await getSociApi(f);
        setSoci(response.data.data);
        endChiamata();
    }

    useEffect(() => {
    }, [certificato]);

    const assegnaSocio = async () => {
        if (certificato && socio && socio !== '') {
            startChiamata();

            await assegnaCertificatoNuovoSocioApi(certificato.id_certificato, (socio && socio.id_utente), certificato);
            endChiamata();
            postUpdate();
            handleClose();
        }
    }

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size={"xl"}
        >
            <NsModalHeader title={"Assegna ad un altro socio"}/>
            <Modal.Body>
                <div className={"row"}>
                    <div className={'col-md-4'}>
                        <input
                            type={"text"}
                            id={"nome"}
                            placeholder={"Nome"}
                            className="form-control"
                            value={nome}
                            onChange={(ev) => {
                                setNome(ev.target.value);
                            }}/>
                    </div>
                    <div className={'col-md-4'}>
                        <input
                            type={"text"}
                            id={"cognome"}
                            placeholder={"Cognome"}
                            className="form-control"
                            value={cognome}
                            onChange={(ev) => {
                                setCognome(ev.target.value);
                            }}/>
                    </div>
                    <div className={'col-md-2'}>
                        <button
                            type={"button"}
                            className={"btn btn-dark"}
                            onClick={() => {
                                getSoci();
                            }}
                            disabled={!cognome}
                        >
                            <i className="fas fa-search"/> <Translate>Cerca</Translate>
                        </button>
                    </div>
                </div>
                <div className={"row mt-2"}>
                    <NsDataTable
                        recordPerPagina={5}
                        data={soci}
                        columns={[
                            {
                                name: 'N° tessera RFI',
                                selector: row => row.numero_tessera_rfi,
                                sortable: true,
                            },
                            {
                                name: 'N° tessera Abarth',
                                selector: row => row.numero_tessera_abarth,
                                sortable: true,
                            },
                            {
                                name: 'Cognome',
                                selector: row => row.cognome,
                                sortable: true,
                            },
                            {
                                name: 'Nome',
                                selector: row => row.nome,
                                sortable: true,
                            },
                            {
                                name: 'Club',
                                selector: row => row.club,
                                sortable: true,
                            },
                            {
                                name: 'Agenzia',
                                selector: row => row.agenzia,
                                sortable: true,
                            },
                            {
                                name: 'Regione',
                                selector: row => row.regione,
                                sortable: true,
                            },
                            {
                                name: 'Provincia',
                                selector: row => row.provincia,
                                sortable: true,
                            },
                            {
                                name: 'Località',
                                selector: row => row.localita,
                                sortable: true,
                            },
                            {
                                name: '',
                                selector: row => <Fragment>
                                    <button
                                        type={"button"}
                                        className={"btn btn-dark"}
                                        onClick={() => {
                                            setSocio(row);
                                        }}
                                    >
                                        <i className="fas fa-check"/>
                                    </button>
                                </Fragment>,
                                sortable: false,
                                right: true,
                            }
                        ]}
                        addPagination={true}
                        addFiltri={false}
                        addDetail={true}
                        getDettaglio={(el) => getRigaInfoSocio(el, false, true)}
                        conditionalRowStyles={(el) => {
                            if (socio && (el.id_utente === socio.id_utente)) {
                                return {
                                    backgroundColor: "rgba(239, 199, 61, 0.25)"
                                }
                            }
                        }}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type={"button"} className="btn btn-dark" onClick={handleClose}>
                    <Translate>Chiudi</Translate>
                </button>
                <button
                    type={"button"}
                    className="btn btn-principal"
                    onClick={() => {
                        assegnaSocio();
                    }}
                    disabled={certificato && (!socio || socio === '')}
                >
                    <Translate>Conferma</Translate>
                </button>
            </Modal.Footer>
        </Modal>
    )

}